module.exports = __webpack_public_path__ + "img/Patch4.2afc3334.webp";